import http from "./http-common";
import authHeader from "./auth-header";
import process from "shelljs";
import qs from "qs";

const API_URL = process.env.BFF_URL;

class ContactService {
  find(customerId, params) {
    return http.get(API_URL + `/v1/customers/${customerId}/contacts`, {
      params: params, paramsSerializer: params => {
        return qs.stringify(params, {arrayFormat: 'repeat'})
      }, headers: authHeader()
    });
  }

  findById(customerId, id) {
    return http.get(API_URL + `/v1/customers/${customerId}/contacts/${id}`, {
      headers: authHeader()
    });
  }

  create(customerId, contact) {
    return http.post(API_URL + `/v1/customers/${customerId}/contacts`, contact, {
      headers: authHeader()
    });
  }

  update(customerId, id, contact) {
    return http.put(API_URL + `/v1/customers/${customerId}/contacts/${id}`, contact, {
      headers: authHeader()
    });
  }

  delete(customerId, id) {
    return http.delete(API_URL + `/v1/customers/${customerId}/contacts/${id}`, {
      headers: authHeader()
    });
  }

  // Direct contact endpoints (without merchant context)
  findByIdDirect(id) {
    return http.get(API_URL + `/v1/contacts/${id}`, {
      headers: authHeader()
    });
  }

  updateDirect(id, contact) {
    return http.put(API_URL + `/v1/contacts/${id}`, contact, {
      headers: authHeader()
    });
  }
}

export default new ContactService();



// WEBPACK FOOTER //
// ./src/service/contact.service.js